import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalController, PopoverController } from '@ionic/angular';
import { GlobalService } from '../../shared/services/global/global.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { VoucherService } from 'src/app/business-service/voucher/voucher.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { PdfService } from '../../shared/services/pdf.service';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { SendViaSocialMediaComponent } from '../../shared/popover/send-via-social-media/send-via-social-media.component';
import { LeadEmailInputComponent } from '../../shared/popover/lead-email-input/lead-email-input.component';
import { EmailService } from '../../shared/services/email/email.service';
import { TableColumnOptionsComponent } from '../../shared/popover/table-column-options/table-column-options.component';
import { ENTITY_NAMES, TRAVEL_SERVICES } from '../../shared/constants/api-constants';
import { WhatsappNumberInputComponent } from '../../shared/popover/whatsapp-number-input/whatsapp-number-input.component';
import { WhatsappService } from '../../shared/services/whatsapp/whatsapp.service';
import { VoucherSelectionPopoverComponent } from '../voucher-selection-popover/voucher-selection-popover.component';

@Component({
  selector: 'app-voucher-view-template',
  templateUrl: './voucher-view-template.component.html',
  styleUrls: ['./voucher-view-template.component.scss'],
})
export class VoucherViewTemplateComponent implements OnInit {

  voucherId: any;
  leadId: any;
  leadDetails: any;
  leadSelectedServices: any;
  quoteId: any;
  voucherTemplateData: any;
  VoucherDataHtml: SafeHtml = "";

  voucherDetails: any;

  constructor(
    private _voucherService: VoucherService,
    private _modalController: ModalController,
    private _responseNotificationService: ResponseNotificationService,
    private _globalService: GlobalService,
    private _sanitizer: DomSanitizer,
    private _pdfService: PdfService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _leadService: LeadsService,
    private _popoverController: PopoverController,
    private _emailService: EmailService,
    private _whatsappService: WhatsappService
  ) { }

  ngOnInit() {
    this._voucherService.getVoucherAsTemplateHtml(this.voucherId).subscribe((data) => {
      this.voucherTemplateData = data;
      this.VoucherDataHtml = this._sanitizer.bypassSecurityTrustHtml(data);
    }, (error) => {
      this._responseNotificationService.showMessage("Something went wrong, please try again", true)
    })

    this._voucherService.getVoucher(this.voucherId).subscribe({
      next: (data) => {
        this.voucherDetails = data;
      },
      error: (error) => {
        console.error('Error fetching voucher details:', error);
        this._responseNotificationService.showMessage("Failed to fetch voucher details, please try again later!", true);
      }
    });

    if (this.leadId) {
      this._leadService.getLead(this.leadId).subscribe((data) => {
        this.leadDetails = data;
      })
    }
  }

  closeModal() {
    this._modalController.dismiss()
  }

  async openDownloadPopover(event: any) {
    const options = [
      { value: "Download", path: "download" },
      { value: "Print", path: "print" }
    ];

    const popover = await this._popoverController.create({
      component: TableColumnOptionsComponent,
      event: event,
      cssClass: 'popup-component popup-component-md',
      componentProps: {
        optionsData: {
          options
        },
        onPathSelected: (data: any) => this.onPrintOptionSelected(data)
      }
    });
    return await popover.present();
  }

  onPrintOptionSelected(data: any) {
    switch (data.path) {
      case "download": {
        this.downloadVoucher();
        break;
      }
      case "print": {
        this.printVoucher();
        break;
      }
    }
    this._popoverController.dismiss();
  }

  // Print funtions
  printVoucher(): void {
    this._pdfService.generatePdf(this.voucherTemplateData).subscribe(
      (blob) => {
        const url = URL.createObjectURL(blob);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;

        iframe.onload = () => {
          iframe.contentWindow?.print();
        };

        document.body.appendChild(iframe);
      },
      (error) => {
        console.error('Error generating PDF:', error);
      }
    );
  }

  async downloadVoucher(): Promise<void> {
    let tempSections: any[] = this.getAvalibleVoucherSections();

    if (tempSections.length === 1) {
      this.downloadIndividualVoucher(tempSections);
    } else {
      const popover = await this._popoverController.create({
        component: VoucherSelectionPopoverComponent,
        cssClass: 'voucher-selection-popover',
        componentProps: {
          voucherDetails: this.voucherDetails,
          leadDetails: this.leadDetails,
          onActionPerformed: (data: any) => {
            if (data) {
              this.downloadIndividualVoucher(data)
            }
          }
        }
      })
      return await popover.present()
    }
  }

  getAvalibleVoucherSections(): any {
    let tempSections: any[] = [];
    if (this.voucherDetails?.showHotels && this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.HOTELS)) {
      tempSections.push("Accommodation");
    }
    if (this.voucherDetails?.showTransportation && this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.TRANSPORTATION)) {
      tempSections.push("Transportation");
    }
    if (this.voucherDetails?.showSightSeeing && this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING)) {
      tempSections.push("RouteCraft");
    }
    return tempSections;
  }

  downloadFullVoucher(): void {
    this._pdfService.generatePdf(this.voucherTemplateData, true).subscribe(
      (blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Voucher _${this.voucherId}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      },
      (error) => {
        console.error('Error generating PDF:', error);
      }
    );
  }

  downloadIndividualVoucher(sections: any) {
    this._voucherService.getIndividualVoucherAsTemplateHtml(this.voucherId, sections).subscribe({
      next: (res) => {
        // After getting html of individual download, then print
        this._pdfService.generatePdf(res, true).subscribe({
          next: (blob) => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `$Voucher _${this.voucherId}.pdf`;
            link.click();
            URL.revokeObjectURL(link.href);
          }, error: (error) => {
            console.error('Error generating PDF:', error);
          }
        });
      }, error: (er) => {
        console.error(er);
        this._responseNotificationService.showMessage("Failed to fetch template, please try again later!", true);
      }
    })
  }

  editVoucher() {
    this.closeModal();
    this._modalPopupService.openVoucherForm(this.voucherId, this.leadId, this.quoteId, () => { })
  }

  async sendVoucher(event: Event) {
    const popover = await this._popoverController.create({
      component: SendViaSocialMediaComponent,
      event: event,
      cssClass: "popup-component-social-media",
      componentProps: {
        onPathSelected: (data: any) => this.onSocialMediaActionOptionSelected(data), // Ensure the function is passed correctly
      }
    })
    return await popover.present()
  }

  onSocialMediaActionOptionSelected(data: any) {
    let selectedOption = data.path;

    switch (selectedOption) {
      case 'whatsApp': {
        this.sendVoucherViaWhatsApp();
        break;
      }
      case 'email': {
        this.sendVoucherViaEmail();
        break;
      }
    }
  }

  async sendVoucherViaWhatsApp() {
    const popover = await this._popoverController.create({
      component: WhatsappNumberInputComponent,
      cssClass: 'whatsapp-popover',
      componentProps: {
        leadPhone: this.leadDetails.phoneNumber,
        onActionPerformed: (data: any) => {
          if (data) {
            let whatsappNumber: string = (data.whatsappNumber?.countryCode || "") + (data.whatsappNumber?.phone || "");

            this._whatsappService.sendDocumentOnWhatsapp(ENTITY_NAMES.VOUCHER, this.voucherId, whatsappNumber).subscribe({
              next: (res) => {
                console.log(res);
                this._responseNotificationService.showMessage("Whatsapp Message Sent!!!");

              }, error: (err) => {
                console.error(err);
                this._responseNotificationService.showMessage("Failed to send whatsapp message", true);

              }
            })
          }
        }
      }
    })
    return await popover.present()
  }

  async sendVoucherViaEmail(): Promise<void> {
    let tempSections: any[] = this.getAvalibleVoucherSections();

    if (tempSections.length === 1) {
      this.sendVoucherViaEmailWithSections(tempSections);
    } else {
      const popover = await this._popoverController.create({
        component: VoucherSelectionPopoverComponent,
        cssClass: 'voucher-selection-popover',
        componentProps: {
          voucherDetails: this.voucherDetails,
          leadDetails: this.leadDetails,
          onActionPerformed: (data: any) => {
            if (data) {
              this.sendVoucherViaEmailWithSections(data)
            }
          }
        }
      })
      return await popover.present()
    }
  }

  async sendVoucherViaEmailWithSections(sections:any) {
    const popover = await this._popoverController.create({
      component: LeadEmailInputComponent,
      cssClass: 'large-popover',
      componentProps: {
        leademail: this.leadDetails.email,
        onActionPerformed: (data: any) => {
          if (data) {
            data.sections = sections;
            this._emailService.sendVoucher(this.voucherId, data).subscribe({
              next: () => {
                this._responseNotificationService.showMessage("Voucher sent via email!");
              },
              error: (error) => {
                console.error('Error sending Voucher via email:', error);
                this._responseNotificationService.showMessage("Failed to send Voucher via email!", true);
              }
            })
          }
        }
      }
    })
    return await popover.present()
  }

}
